export const PLAY_AUDIO = 'AudioPlayer/PLAY_AUDIO';
export const STOP_AUDIO = 'AudioPlayer/STOP_AUDIO';
export const SET_SOUNDS = 'AudioPlayer/SET_SOUNDS';
export const SELECT_SOUND = 'AudioPlayer/SELECT_SOUND';
